<template>
    <div>
        <div style="display: flex; gap: 10px;">
            <div style="flex: 1;">
                <div>{{ this.$t('AppAlertsCoaAlertsConfigForm.Código do Alerta') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['code_alert']" disabled 
                    :class="{'p-invalid': $v.form.code_alert.$error && $v.form.code_alert.$dirty}"/>
            </div>
            <div style="flex: 1;">
                <div>{{ this.$t('AppAlertsCoaAlertsConfigForm.Dicionário') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['dictionary']" disabled 
                    :class="{'p-invalid': $v.form.dictionary.$error && $v.form.dictionary.$dirty}"/>
            </div>
            <div style="flex: 1;">
                <div>{{ this.$t('AppAlertsCoaAlertsConfigForm.Modelo') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['model_name']" disabled 
                    :class="{'p-invalid': $v.form.dictionary.$error && $v.form.dictionary.$dirty}"/>
            </div>
        </div>

        <div style="display: flex; gap: 10px; margin-top: 10px;">
            <div style="flex: 1;">
                <div>{{ this.$t('AppAlertsCoaAlertsConfigForm.Descrição') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['description']" disabled 
                    :class="{'p-invalid': $v.form.description.$error && $v.form.description.$dirty}"/>
            </div>
            <div style="flex: 1;">
                <div>{{ this.$t('AppAlertsCoaAlertsConfigForm.Descrição COA') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['description_coa']" 
                    :class="{'p-invalid': $v.form.description_coa.$error && $v.form.description_coa.$dirty}"/>
            </div>
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Status') }}</div>
                <Dropdown v-model="form['status']" :options="optionsStatus" :filter="true"
                        style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="code" optionValue="code"
                        :class="{'p-invalid': $v.form.status.$error && $v.form.status.$dirty}">
                    <template #value="slotProps">
                        <span :class="'badge statusAlert-' + slotProps.value" style="margin-right: 5px;">
                            {{ getStatus(slotProps.value) }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <span :class="'badge statusAlert-' + slotProps.option.code">
                            {{ getStatus(slotProps.option.code) }}
                        </span>
                    </template>
                </Dropdown>
            </div>
        </div>

        <div style="display: flex; gap: 10px; margin-top: 10px;">
            <div style="flex: 1;">
                <div>FMI</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['fmi']" disabled 
                    :class="{'p-invalid': $v.form.description.$error && $v.form.description.$dirty}"/>
            </div>
            <div style="flex: 1;">
                <div>{{ this.$t('AppAlertsCoaAlertsConfigForm.Criticidade do COA') }}</div>
                <Dropdown v-model="form['criticality_level_coa']" :options="optionsCriticalityLevel" :filter="true"
                        style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="code" optionValue="code"
                        :class="{'p-invalid': $v.form.criticality_level_coa.$error && $v.form.criticality_level_coa.$dirty}">
                    <template #value="slotProps">
                        <span :class="'badge criticalityLevel-' + slotProps.value" style="margin-right: 5px;">
                            {{ getCriticalityLevel(slotProps.value) }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <span :class="'badge criticalityLevel-' + slotProps.option.code">
                            {{ getCriticalityLevel(slotProps.option.code) }}
                        </span>
                    </template>
                </Dropdown>
            </div>
            <div style="flex: 1;"></div>
        </div>

        <div style="float: right; margin-top: 20px;">
            <Button :label="$t('AppAlertsCoaAlertsConfig.Cancelar')" icon="pi pi-times" class="p-button-text p-button-danger" @click="$emit('closeDialog')"/>
            <Button :label="$t('AppAlertsCoaAlertsConfig.Confirmar')" icon="pi pi-check" :disabled="disabledConfirm" class="p-button-text" @click="validate" />
        </div>
    </div>
</template>

<script>
import AlertsCoaService from '@/services/AlertsCoaService';
import {required} from 'vuelidate/lib/validators';
import InputText from 'primevue/inputtext/InputText';
import Button from 'primevue/button/Button';
import {STATUSES_ALERT, FMI_LIST, CRITICALY_LEVELS} from '../AppOptionsCoa';
import Dropdown from 'primevue/dropdown/Dropdown';
import displayToast from '@/mixins/ToastMixin';

export default {
    mixins: [displayToast],
    props: {
        dataToEditMachine: {
            type: Object
        },
    },
    data() {
        return {
            alertsCoaService: null,
            form: {
                code_alert: '',
                description: '',
                dictionary: 0
            },
            dictionaries: [
                { label: this.$t('AppAlertsCoaAlertsConfigForm.Proprietário'), value: "PROPRIETARY" },
                { label: "J1939", value: "J1939" }
            ],
            optionsStatus: STATUSES_ALERT,
            isNewAlert: false,
            fmiOptions: FMI_LIST,
            optionsCriticalityLevel: CRITICALY_LEVELS,
            disabledConfirm: false
        }
    },
    created() {
        this.alertsCoaService = new AlertsCoaService();
    },
    mounted() {
        this.getParametricFailureMachine()
    },
    methods: {
        getCriticalityLevel(status) {
            let result = this.optionsCriticalityLevel.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        getStatus(status) {
            let result = this.optionsStatus.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        getParametricFailureMachine(){
            this.isNewAlert = this.dataToEditMachine.id === null ? true : false
            this.form = { ... this.dataToEditMachine }
            this.form.dictionary = this.dictionaries[this.form.dictionary].label
            this.form.fmi = this.form.fmi != null ? this.fmiOptions[this.dataToEditMachine.fmi].name : null
        },
        validate(){
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                this.saveAlert()
            } else {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Por favor preencha todos os campos obrigatórios'), 'e')
            }
        },
        saveAlert(){
            this.disabledConfirm = true
            let newForm = { ...this.form }
            newForm.dictionary = this.dataToEditMachine.dictionary
            newForm.fmi = this.dataToEditMachine.fmi

            if(this.isNewAlert){
                this.createAlert(newForm)
                return
            }

            this.editAlert(newForm)
        },
        createAlert(newForm) {
            this.alertsCoaService.createMachineAlert(this.dataToEditMachine.organization_id, newForm).then((data) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Criado com sucesso'), 's')
                    this.$emit('reloadFailures');
                }).catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível criar o alerta'), 'e', error)
                }).finally(() => {
                    this.disabledConfirm = false
                })
        },
        editAlert(newForm) {
            this.alertsCoaService.editMachineAlert(this.dataToEditMachine.organization_id, newForm.id, newForm).then((data) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Editado com sucesso'), 's')
                    this.$emit('reloadFailures');
                }).catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível editar o alerta'), 'e', error)
                }).finally(() => {
                    this.disabledConfirm = false
                })
        }
    },
    validations: {
        form: {
            code_alert: {required},
            description: {required},
            dictionary: {required},
            description_coa: {required},
            status: {required},
            criticality_level_coa: {required}
        }
    },
    components: {
        InputText, Button, Dropdown
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";
</style>